import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import storage from '../../../apis/Storage'
import { ADD_NOTIFICATION, GET_NOTIFICATIONS } from '../../../Types'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export const addNotification = (formValues) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post('api/Notification', formValues)
    .then(({ data }) => {
      console.log('noti listing : ', data)
      if (data.response)
        dispatch({
          type: ADD_NOTIFICATION,
          payload: data.response,
        })
      dispatch(hideLoading())
      toast.success('Notification sent successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      } else toast.error('Error while processing the request')
    })
}

export const getNotifications = (req) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/Notification/GetGeneralNotifications`, req)
    .then(({ data }) => {
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: data.response,
      })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
